import { graphql } from '@/client/services/api/graphql/gql';

export const enableExpertMutation = graphql(`
  mutation EnableExpert($expertId: String!) {
    enableExpert(expertId: $expertId)
  }
`);
